import React from "react";
import { alpha } from "@mui/material/styles";
import { Box, Chip, Stack, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DirectionsBusOutlinedIcon from "@mui/icons-material/DirectionsBusOutlined";
import EventSeatOutlinedIcon from "@mui/icons-material/EventSeatOutlined";
import { tripHasConexao, tripItineraryLabel } from "./bpeTripDisplay";

/**
 * Resumo compacto do trecho/horário — uma linha sempre que possível.
 */
export default function BPeTripContextBar({
  routeSummary,
  trip,
  selectedSeats,
  formatPrice,
  normalizeClasse,
  t,
}) {
  if (!routeSummary && !trip) return null;

  const classe = trip && normalizeClasse ? normalizeClasse(trip.classe) : "";
  const price = trip && formatPrice ? formatPrice(trip.valor) : null;

  return (
    <Box
      sx={{
        mb: 1,
        py: 0.75,
        px: 1.25,
        borderRadius: 1.5,
        border: 1,
        borderColor: "primary.main",
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05),
        flexShrink: 0,
      }}
    >
      <Stack direction="row" flexWrap="wrap" gap={0.5} alignItems="center">
        {routeSummary && (
          <Typography variant="caption" fontWeight={700} sx={{ mr: 0.25, lineHeight: 1.3 }}>
            {routeSummary}
          </Typography>
        )}
        {trip && (
          <>
            <Chip
              size="small"
              icon={<AccessTimeIcon sx={{ fontSize: "14px !important" }} />}
              label={`${trip.inicio || "—"} → ${trip.fim || "—"}`}
              sx={{ height: 24, fontWeight: 600, "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem" } }}
            />
            {classe ? (
              <Chip
                size="small"
                icon={<EventSeatOutlinedIcon sx={{ fontSize: "14px !important" }} />}
                label={classe}
                variant="outlined"
                sx={{ height: 24, "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem" } }}
              />
            ) : null}
            {price ? (
              <Chip
                size="small"
                label={price}
                color="primary"
                variant="outlined"
                sx={{ height: 24, fontWeight: 700, "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem" } }}
              />
            ) : null}
            {tripHasConexao(trip) ? (
              <Chip
                size="small"
                color="info"
                variant="outlined"
                label={tripItineraryLabel(trip) || t("bpeWizard.withConnection")}
                sx={{
                  height: 24,
                  maxWidth: 280,
                  fontWeight: 700,
                  "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem", overflow: "hidden", textOverflow: "ellipsis" },
                }}
              />
            ) : null}
            {trip.viacao ? (
              <Chip
                size="small"
                icon={<DirectionsBusOutlinedIcon sx={{ fontSize: "14px !important" }} />}
                label={trip.viacao}
                variant="outlined"
                sx={{
                  height: 24,
                  maxWidth: 160,
                  "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem", overflow: "hidden", textOverflow: "ellipsis" },
                }}
              />
            ) : null}
          </>
        )}
        {selectedSeats?.length ? (
          <Chip
            size="small"
            icon={<EventSeatOutlinedIcon sx={{ fontSize: "14px !important" }} />}
            label={t("bpeWizard.seatsFooterSummary", {
              seats: selectedSeats.map((s) => String(s).padStart(2, "0")).join(", "),
            })}
            color="success"
            variant="outlined"
            sx={{ height: 24, fontWeight: 700, "& .MuiChip-label": { px: 0.75, fontSize: "0.72rem" } }}
          />
        ) : null}
      </Stack>
    </Box>
  );
}
